exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.website-url[data-v-30669128]{font-size:1.25rem;margin-top:10px;display:inline-block}.button[data-v-30669128]{border:none;margin:4px 2px;margin-bottom:10px;margin-right:10px;right:0;border-radius:4px;border-radius:25px}.button[data-v-30669128],.rentRollBtn[data-v-30669128]{text-transform:uppercase;color:#fff;padding:13px 32px;text-align:center;text-decoration:none;display:inline-block;font-size:13px;position:absolute;bottom:0;cursor:pointer;font-weight:700}.rentRollBtn[data-v-30669128]{background-color:#a82322;border:none;margin-bottom:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-30669128","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/property/PropertySummary.vue
// module id = 7zv8
// module chunks = 0 1